import React from 'react';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import MoneyOffOutlinedIcon from '@mui/icons-material/MoneyOffOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import StatCard from '../components/StatCard';
import ChartBlock from '../components/ChartBlock';
import TimelineChart from '../components/TimelineChart';
import DonutChart from '../components/DonutChart';
import RankList from '../components/RankList';
import InsuranceStats from './InsuranceStats';
import styles from '../components/stats.module.css';
import palette from '../components/palette';
import { formatMoney, granularityHint } from '../utils/format';

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

export function financialCards(data) {
  return [
    { key: 'received', label: 'Recebido', icon: <PaymentsOutlinedIcon />, type: 'money', accent: 'green' },
    { key: 'expenses', label: 'Despesas', icon: <MoneyOffOutlinedIcon />, type: 'money', inverse: true, accent: 'pink' },
    { key: 'result', label: 'Resultado', icon: <AccountBalanceWalletOutlinedIcon />, type: 'money', accent: 'blue' },
    { key: 'margin', label: 'Margem', icon: <PercentOutlinedIcon />, type: 'percent', accent: 'blue' },
    {
      key: 'ticket', label: 'Ticket médio', icon: <ConfirmationNumberOutlinedIcon />, type: 'money', accent: 'purple',
      hint: plural(data.paidCount, 'pagamento de atendimento', 'pagamentos de atendimento'),
    },
    {
      key: 'unpaidAmount', label: 'Sem pagamento registrado', icon: <ReceiptLongOutlinedIcon />, type: 'money', inverse: true, accent: 'amber',
      hint: plural(data.unpaidCount, 'atendimento realizado', 'atendimentos realizados'),
    },
    {
      key: 'forecastAmount', label: 'Previsto', icon: <EventNoteOutlinedIcon />, type: 'money', accent: 'teal',
      hint: plural(data.forecastCount, 'atendimento por vir', 'atendimentos por vir'),
    },
  ];
}

export const moneyItems = (list, extra) => list.map((item) => ({
  label: item.label,
  value: item.amount,
  display: formatMoney(item.amount),
  ...(extra ? extra(item) : {}),
}));

const FinancialSection = ({ data, granularity }) => (
  <>
    <div className={styles.grid}>
      {financialCards(data).map((card) => <StatCard key={card.key} {...card} kpi={data.kpis[card.key]} />)}
    </div>

    <div className={styles.row}>
      <ChartBlock title="Entradas e saídas" hint={granularityHint(granularity)}>
        <TimelineChart
          data={data.timeline}
          granularity={granularity}
          money
          series={[
            { key: 'received', label: 'Recebido', color: palette.green },
            { key: 'expenses', label: 'Despesas', color: palette.pink },
          ]}
        />
      </ChartBlock>
      <ChartBlock title="Formas de pagamento" hint="atendimentos pagos">
        <DonutChart
          items={moneyItems(data.paymentMethods)}
          centerValue={data.paymentMethods.reduce((sum, item) => sum + item.count, 0)}
          centerLabel="pagamentos"
          empty="Nenhum pagamento de atendimento no período."
        />
      </ChartBlock>
    </div>

    <InsuranceStats insurance={data.insurance} />

    <div className={styles.rowEven}>
      <ChartBlock title="Receita por procedimento">
        <RankList items={moneyItems(data.byProcedure)} color={palette.blue} empty="Nenhum pagamento de atendimento no período." />
      </ChartBlock>
      <ChartBlock title="Receita por profissional">
        <RankList items={moneyItems(data.byResource)} color={palette.purple} empty="Nenhum pagamento de atendimento no período." />
      </ChartBlock>
    </div>

    <div className={styles.rowEven}>
      <ChartBlock title="Receitas por categoria">
        <RankList items={moneyItems(data.incomeByCategory)} color={palette.green} empty="Nenhuma receita lançada no período." />
      </ChartBlock>
      <ChartBlock title="Despesas por categoria">
        <RankList items={moneyItems(data.expenseByCategory)} color={palette.pink} empty="Nenhuma despesa lançada no período." />
      </ChartBlock>
    </div>
  </>
);

export default FinancialSection;
